// 轻量 SVG 图标组件（零依赖），替代 emoji，保证跨平台一致性
import type { CSSProperties } from 'react';

export type IconName =
  | 'search' | 'chart' | 'trophy' | 'book' | 'settings'
  | 'camera' | 'check' | 'close' | 'arrow-right' | 'arrow-left'
  | 'star' | 'star-filled' | 'sparkles' | 'refresh' | 'calendar'
  | 'alert' | 'book-open' | 'chevron-right' | 'home' | 'user'
  | 'lightbulb' | 'target' | 'clock' | 'fire' | 'medal'
  | 'logout' | 'menu' | 'edit' | 'trash' | 'download'
  | 'play' | 'lock' | 'shield' | 'qrcode'
  | 'check-circle' | 'alert-circle' | 'close-circle'
  | 'spade' | 'heart' | 'club' | 'diamond' | 'joker' | 'bell';

const PATHS: Record<IconName, JSX.Element> = {
  search: <path d="M11 19a8 8 0 1 1 5.3-2l4.3 4.3-1.4 1.4-4.3-4.3A8 8 0 0 1 11 19Zm0-2a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"/>,
  chart: <><path d="M4 20V10M10 20V4M16 20v-7M22 20H2"/></>,
  trophy: <path d="M6 4h12v3a6 6 0 0 1-12 0V4Zm-2 0H2v2a3 3 0 0 0 3 3m13-5h2v2a3 3 0 0 1-3 3M8 20h8m-6 0v-4m4 4v-4M9 4h6v3a3 3 0 0 1-6 0V4Z"/>,
  book: <path d="M4 4.5A2.5 2.5 0 0 1 6.5 2H20v17H6.5A2.5 2.5 0 0 0 4 21.5v-17Zm0 0v14A2.5 2.5 0 0 0 6.5 21H20"/>,
  settings: <><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1.08-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1.08 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z"/></>,
  camera: <><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2Z"/><circle cx="12" cy="13" r="4"/></>,
  check: <path d="M20 6 9 17l-5-5"/>,
  close: <path d="M18 6 6 18M6 6l12 12"/>,
  'arrow-right': <path d="M5 12h14M13 5l7 7-7 7"/>,
  'arrow-left': <path d="M19 12H5M12 19l-7-7 7-7"/>,
  star: <path d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2Z"/>,
  'star-filled': <path d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2Z"/>,
  sparkles: <path d="M12 3v4m0 10v4M3 12h4m10 0h4M5.6 5.6l2.8 2.8m7.2 7.2 2.8 2.8m0-12.8-2.8 2.8M8.4 15.6l-2.8 2.8"/>,
  refresh: <path d="M21 12a9 9 0 1 1-3-6.7L21 8M21 3v5h-5"/>,
  calendar: <><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></>,
  alert: <><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"/><path d="M12 9v4M12 17h.01"/></>,
  'book-open': <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2Zm20 0h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7Z"/>,
  'chevron-right': <path d="m9 18 6-6-6-6"/>,
  home: <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z"/>,
  user: <><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></>,
  lightbulb: <path d="M9 18h6M10 22h4M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.3 1 2.1V18h6v-1.2c0-.8.4-1.6 1-2.1A7 7 0 0 0 12 2Z"/>,
  target: <><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></>,
  clock: <><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></>,
  fire: <path d="M12 2c1 3 4 5 4 9a4 4 0 0 1-8 0c0-1.5.5-2.5 1-3 .3 1 .8 1.5 1.5 1.5C11 9 11.5 5 12 2Z"/>,
  medal: <><circle cx="12" cy="15" r="6"/><path d="M8.5 10 7 2h10l-1.5 8M9 19l-2 3m7-3 2 3"/></>,
  logout: <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/>,
  menu: <path d="M3 12h18M3 6h18M3 18h18"/>,
  edit: <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.1 2.1 0 0 1 3 3L12 15l-4 1 1-4Z"/>,
  trash: <path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>,
  download: <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3"/>,
  play: <path d="M6 4l14 8-14 8Z"/>,
  lock: <><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></>,
  shield: <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"/>,
  qrcode: <><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 14h3v3M21 14v7M14 21h3M17 17h4"/></>,
  'check-circle': <><circle cx="12" cy="12" r="10"/><path d="m8 12 3 3 5-6"/></>,
  'alert-circle': <><circle cx="12" cy="12" r="10"/><path d="M12 8v5M12 16h.01"/></>,
  'close-circle': <><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6M9 9l6 6"/></>,
  spade: <path d="M12 2C8 6 5 9 5 13a4 4 0 0 0 7 2.6V19H9m6-3.4V19h-3" fill="currentColor" stroke="none"/>,
  heart: <path d="M12 21s-7-4.5-9.5-9A5 5 0 0 1 12 6a5 5 0 0 1 9.5 6c-2.5 4.5-9.5 9-9.5 9Z" fill="currentColor" stroke="none"/>,
  club: <path d="M12 17a4 4 0 1 0-3-6.6A4 4 0 1 0 6 17h3v2H6m12-2a4 4 0 1 0-3-6.6A4 4 0 1 0 15 17h-3v2h3" fill="currentColor" stroke="none"/>,
  diamond: <path d="M12 2 4 12l8 10 8-10Z" fill="currentColor" stroke="none"/>,
  joker: <><path d="M14 2H9a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Z"/><circle cx="12" cy="9" r="2.5"/><path d="M9 18c.8-1.5 1.8-2.5 3-2.5s2.2 1 3 2.5"/></>,
  bell: <><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.7 21a2 2 0 0 1-3.4 0"/></>,
};

interface IconProps {
  name: IconName;
  size?: number;
  color?: string;
  filled?: boolean;
  strokeWidth?: number;
  className?: string;
  style?: CSSProperties;
}

export function Icon({ name, size = 20, color = 'currentColor', filled = false, strokeWidth = 2, className, style }: IconProps) {
  const isFilled = filled || name === 'check' || name === 'close' || name === 'star-filled';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={isFilled ? color : 'none'}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0, ...style }}
      aria-hidden="true"
    >
      {PATHS[name]}
    </svg>
  );
}
